module.exports = __webpack_public_path__ + "static/media/gmail.43f0d00b.png";